<template>
    <div class="analytics-section">
        <div
            v-if="loading"
            class="analytics-section__skeleton"
        >
            <div class="analytics-section__skel-row analytics-section__skel-row--kpis">
                <div v-for="i in 3" :key="`k${i}`" class="analytics-section__skel" style="height:140px" />
            </div>
            <div class="analytics-section__skel" style="height:200px" />
            <div class="analytics-section__skel-row analytics-section__skel-row--split">
                <div class="analytics-section__skel" style="height:340px" />
                <div class="analytics-section__skel" style="height:340px" />
            </div>
        </div>

        <template v-else-if="showEmpty">
            <analytics-empty-state :variant="emptyVariant" />
        </template>

        <template v-else>
            <analytics-totals
                v-if="totalsData"
                class="analytics-section__totals"
                :totals="totalsData"
            />
            <analytics-section-error
                v-else
                label="Não foi possível carregar os totais."
            />

            <analytics-activities
                v-if="activitiesData"
                class="analytics-section__activities"
                :activities="activitiesData"
            />
            <analytics-section-error
                v-else
                label="Conversões temporariamente indisponíveis."
            />

            <div class="analytics-section__bottom">
                <analytics-geo-list
                    v-if="geoData"
                    :geo="geoData"
                />
                <analytics-section-error
                    v-else
                    label="Distribuição geográfica indisponível."
                />

                <analytics-system
                    v-if="systemData"
                    :system="systemData"
                />
                <analytics-section-error
                    v-else
                    label="Distribuição de dispositivos indisponível."
                />
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'AnalyticsSection',
    props: {
        analytics: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        hasSite() {
            return !!(this.analytics && this.analytics.has_site === true)
        },
        totalsData() {
            return this.analytics?.totals?.data || null
        },
        activitiesData() {
            return this.analytics?.activities?.data || null
        },
        geoData() {
            const raw = this.analytics?.geo?.data
            return Array.isArray(raw) ? raw : null
        },
        systemData() {
            const raw = this.analytics?.system?.data
            return Array.isArray(raw) ? raw : null
        },
        allSectionsFailed() {
            if (!this.analytics) return true
            return !this.totalsData
                && !this.activitiesData
                && !this.geoData
                && !this.systemData
        },
        showEmpty() {
            if (!this.analytics) return true
            if (!this.hasSite) return true
            return this.allSectionsFailed
        },
        emptyVariant() {
            if (this.analytics && this.hasSite && this.allSectionsFailed) return 'error'
            return 'no-site'
        },
    },
}
</script>

<style scoped>
.analytics-section {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.analytics-section__bottom {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
}

@media (min-width: 1024px) {
    .analytics-section__bottom {
        grid-template-columns: 1fr 1fr;
    }
}

.analytics-section__skeleton {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.analytics-section__skel-row {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
}

@media (min-width: 768px) {
    .analytics-section__skel-row--kpis { grid-template-columns: repeat(3, 1fr); }
}

@media (min-width: 1024px) {
    .analytics-section__skel-row--split { grid-template-columns: 1fr 1fr; }
}

.analytics-section__skel {
    border-radius: var(--radius-lg);
    background: linear-gradient(110deg, rgba(112, 42, 225, 0.06) 8%, rgba(112, 42, 225, 0.12) 18%, rgba(112, 42, 225, 0.06) 33%);
    background-size: 200% 100%;
    animation: analyticsShimmer 1.6s linear infinite;
    border: 1px solid rgba(255, 255, 255, 0.45);
}

html.theme-dark .analytics-section__skel {
    background: linear-gradient(110deg, rgba(189, 157, 255, 0.05) 8%, rgba(189, 157, 255, 0.1) 18%, rgba(189, 157, 255, 0.05) 33%);
    background-size: 200% 100%;
    border-color: rgba(255, 255, 255, 0.06);
}

@keyframes analyticsShimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}
</style>
